import React, { Component } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Collapse
} from 'reactstrap';

import "./Standardslide.css"
const items = [];
items["Identification"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-6.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-7.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-8.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-9.jpg"
  }
];

items["Patterns"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-10.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-11.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-12.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-13.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-14.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-15.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-16.jpg"
  }
];

items["Information"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-17.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-18.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-19.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-20.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-21.jpg"
  }
];

items["Mediation"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-22.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-23.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-24.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-25.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-26.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-27.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-28.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-29.jpg"
  },
];

items["Scaling"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-30.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-31.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-32.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-33.jpg"
  }
];

items["Security"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-34.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-35.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-36.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-37.jpg"
  }
];

items["Reliability"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-38.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-39.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-40.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-41.jpg"
  }
];

items["Operability"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-42.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-43.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-44.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-45.jpg"
  }
];

items["Future"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-46.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-47.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-48.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-49.jpg"
  }
];

items["Integration"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-50.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-51.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-52.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-53.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-54.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-55.jpg"
  }
];

items["Ownership"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-57.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-58.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-59.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-60.jpg"
  }
];

items["Reuse"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-61.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-62.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-63.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-64.jpg"
  }
];

items["Discovery"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-65.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-66.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-67.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-68.jpg"
  }
];

items["Marketing"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-69.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-70.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-71.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-72.jpg"
  }
];

items["Landscape"] = [
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-73.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-74.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-75.jpg"
  },
  {
    src: "/images/Certified-Integrator-Pitch-konvertera-76.jpg"
  }
];




class Standardslide extends Component {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
    this.toggle = this.toggle.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.state = {
      activeIndex: 0,
      popoverOpen: false,
      activeItem: [],
      collapse: false,
      condition: false,
      collapse2: false,
      condition2: false
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
    this.changeSlideImages = this.changeSlideImages.bind(this);

  }
  toggle() {
    this.setState(state => ({ collapse: !state.collapse, condition: !this.state.condition }));
  }
  toggle2() {
    this.setState(state => ({ collapse2: !state.collapse2, condition2: !this.state.condition2 }));
  }
  componentDidMount() {
    this.setState({ activeItem: items['Identification'] });
  }

  changeSlideImages(category) {
    this.setState({ activeItem: items[category] });
    window.scrollTo(0, this.sliderRef.current.offsetTop)
  }
  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === this.state.activeItem.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.state.activeItem.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }



  render() {
    const { activeIndex } = this.state;

    const slides = this.state.activeItem.map((item) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <img src={item.src} alt={item.altText} className="img-fluid d-block mx-auto" />

        </CarouselItem>
      );
    });

    return (
      <Container className="content-wrapper p-b-0 standardslide-wrapper" >
        <div ref={this.sliderRef}>
          <h3 className="text-center">The Standard</h3>
          <Carousel
            activeIndex={activeIndex}
            next={this.next}
            previous={this.previous}
            interval={false}
          >
            {slides}
            <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
            <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
          </Carousel>
          <p className="copyright" id="materials">Copyright © 2021 Entiros. All rights reserved</p>
          <Container className="essentials mb-5">
            <p className="text-center pointer" onClick={this.toggle}>
              10 essentials for an end-to-end integration
              <span onClick={this.toggle} className={this.state.condition ? "arrow-down-yellow toggled" : "arrow-down-yellow"}></span>
            </p>

            <Collapse isOpen={this.state.collapse}>
              <Row className="essential-first">
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">1</span>
                  <Card onClick={() => this.changeSlideImages("Identification")}>
                    <CardBody>
                      <CardTitle>Identification - with Registry</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">2</span>
                  <Card onClick={() => this.changeSlideImages("Patterns")}>
                    <CardBody>
                      <CardTitle>Patterns – with Contracts & Services</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">3</span>
                  <Card onClick={() => this.changeSlideImages("Information")}>
                    <CardBody>
                      <CardTitle>
                        Information – with Requirements Coordination
                </CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">4</span>
                  <Card onClick={() => this.changeSlideImages("Mediation")}>
                    <CardBody>
                      <CardTitle>Mediation – with Test Coordination</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">5</span>
                  <Card onClick={() => this.changeSlideImages("Scaling")}>
                    <CardBody>
                      <CardTitle>Scaling – with Capacity testing</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">6</span>
                  <Card onClick={() => this.changeSlideImages("Security")}>
                    <CardBody>
                      <CardTitle>Security – with CIA Ensured</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">7</span>
                  <Card onClick={() => this.changeSlideImages("Reliability")}>
                    <CardBody>
                      <CardTitle>Reliability – with Reliability Options</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">8</span>
                  <Card onClick={() => this.changeSlideImages("Operability")}>
                    <CardBody>
                      <CardTitle>Operability – with Trace & Error handling</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">9</span>
                  <Card onClick={() => this.changeSlideImages("Future")}>
                    <CardBody>
                      <CardTitle>
                        Future proofing – with Life-cycle Mgmt & Versioning
                </CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">10</span>
                  <Card onClick={() => this.changeSlideImages("Integration")}>
                    <CardBody>
                      <CardTitle>Integration Documentation - Repository</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <div className="clearfix" />
              </Row>
            </Collapse>


            <p className="text-center pointer" onClick={this.toggle2}>
              5 essentials for a landscape of integrations
              <span onClick={this.toggle2} className={this.state.condition2 ? "arrow-down-yellow toggled" : "arrow-down-yellow"}></span>
            </p>
            <Collapse isOpen={this.state.collapse2}>
              <Row className="essential-second">
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">1</span>
                  <Card onClick={() => this.changeSlideImages("Ownership")}>
                    <CardBody>
                      <CardTitle>Ownership & Audiences</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">2</span>
                  <Card onClick={() => this.changeSlideImages("Reuse")}>
                    <CardBody>
                      <CardTitle>Reuse & Architecture</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">3</span>
                  <Card onClick={() => this.changeSlideImages("Discovery")}>
                    <CardBody>
                      <CardTitle>Discovery & Governance</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">4</span>
                  <Card onClick={() => this.changeSlideImages("Marketing")}>
                    <CardBody>
                      <CardTitle>Marketing & Onboarding</CardTitle>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" sm="6" md="4" className="mb-2">
                  <span className="essential-no">5</span>
                  <Card onClick={() => this.changeSlideImages("Landscape")}>
                    <CardBody>
                      <CardTitle>Landscape Documentation</CardTitle>
                    </CardBody>
                  </Card>
                </Col>

                <div className="clearfix" />
              </Row>
            </Collapse>
          </Container>
        </div>
      </Container>
    );
  }
}


export default Standardslide;
